
import { distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TurbineCockpit } from 'app/models/monitor/turbine-cockpit.model';
import { ParkSignalsListGQL, Stream, TurbineCockpitGQL } from '../../graphql';

@Injectable()
export class TurbineCockpitService {

  constructor(
    private turbineCockpit: TurbineCockpitGQL,
    private parkSignalsList: ParkSignalsListGQL
  ) { }

  public getTurbineCockpitInfo(signalsListObs): Observable<TurbineCockpit> {
    return signalsListObs.pipe(
      distinctUntilChanged(),
      switchMap((data: any) => {
        return this.turbineCockpit.subscribe({
          variables: {
            serialNav: data.serialNav,
            requestedSignals: Array.from(new Set(data.signalsList.map(item => item.name))),
            requestedTtempSignals: Array.from(new Set(data.tempSignalsList.map(item => item.name)))}
        }).pipe(map(result => TurbineCockpit.setSignals(result.data.turbines[0], data)))
      }
      )
    );
  }

  public getParkSignalsList(turbineSerialObservable: Observable<number>, streamType: Stream) {
    return turbineSerialObservable.pipe(
      distinctUntilChanged(),
      switchMap(turbineSerial => {
        return this.parkSignalsList.fetch({
          variables: {
          serialNav: turbineSerial, streamType}
        }).pipe(
          map(result => result.data.turbines)
        )
      })
    );
      
      
  }


}
